export const LANG_LIST = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'zh',
    label: '简体中文',
  },
]

//  Align with 'LANG_LIST'; Add or delete according to 'LANG_LIST',
export const LANG_VALUES_MAP = new Map([
  ['en', ['en', 'en_US']],
  ['zh', ['zh', 'zh_CN']],
])

export const RESOURCE_TYPE = {
  sources: 'sources',
  sinks: 'sinks',
  functions: 'functions',
  operators: 'operators',
  connections: 'connections',
}

export const DEFAULT_RESOURCE_TYPE = RESOURCE_TYPE.sources
